import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ProgressBar-module_bgBar__Jd-Ge{background:var(--separator);width:120px}.ProgressBar-module_bgBar__Jd-Ge,.ProgressBar-module_progress__J2mNo{border-radius:var(--radius-list-item);box-shadow:inset 0 -1px 0 0 rgb(var(--neutral-white-raw)/.2),inset 0 1px 0 0 rgb(var(--neutral-white-raw)/.2);height:8px}.ProgressBar-module_progress__J2mNo{background:var(--text-accent-primary-label);transition:.6s cubic-bezier(.6,0,.38,1);width:50px}";
var style = {"bgBar":"ProgressBar-module_bgBar__Jd-Ge","progress":"ProgressBar-module_progress__J2mNo"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=ProgressBar.module.css.js.map
